import React, { useState, useEffect }  from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Button, Paper,CircularProgress,Typography } from "@material-ui/core";
import MainContainer from "../../../components/MainContainer";
import { headerDataMission } from "../../../data/modules/mission-header"; 
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Message from "../../tools/Message";
import TDRService from "../../../services/TDRService";
import AllPages from "./AllPages";
import LoadingButton from '@mui/lab/LoadingButton';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    elevation: 0
  },
}));

export default function PlanningPDF() {
  const navigate = useNavigate();
  const location = useLocation();
  const classes = useStyles();
   const pathname = window.location.pathname;
  const segments = pathname.split('/');
//   const missionId = segments[segments.length - 1];
  const { id, agenda} = useParams();
  const missionId = id ?? null;
  const agendaId = agenda ?? null;
  const firstAgendaId = location.state?.firstAgendaId ?? agendaId ?? null;
  const [filename,setFilename]=useState(null);
  const lienpdf=process.env.REACT_APP_API_URL_FILE;
  const [loading, setLoading] = useState(true);
  const [opendialogue,setOpendialogue]=useState(false);
  const [selectedValidateurs, setSelectedValidateurs] = useState([]);
  const [error, setError] = useState(null);
  const [timesheetDialog, setTimesheetDialog] = useState(false);
  const [message, setMessage] = React.useState({
    open: false,
    color: 'green',
    messageInfo: '',
  });
  const { open, color, messageInfo } = message;
  const [isLoading,setIsloading]=useState(false);


  function handleCloseMessage(){
    setMessage({...message, open: false});
  }

  useEffect(() => {
    TDRService.filenamepdf(missionId).then((result) => {
      if (result && result.data) {
         const lienfinal=lienpdf+"/"+result.data+".pdf";
         setFilename(lienfinal)
         setLoading(false)
      }
    });
    
    TDRService.validateurmission(missionId).then((result) => {
      if (result && result.data) {
         setSelectedValidateurs(result.data);
      }
    });

  }, []);


  const handleretour = () => {
    navigate('/mission/planning_mission/detail/'+missionId); 
  };

  const handleClose = () => {
    navigate('/mission/planning_mission');
  };

  const handleValidate = () => {
     setOpendialogue(true);
  };

   function handleCloseDialogue(){
     setOpendialogue(false);
   }

   const handleValidateConfirm = () => {
     setIsloading(true);

     const validateurFinal = selectedValidateurs.reduce((acc, current) => {
        const existing = acc.find(item => item.missionaire_id === current.missionaire_id);
        if (existing) {
          existing.validateurs.push(current.user_id);
        } else {
          acc.push({
            missionaire_id: current.missionaire_id,
            validateurs: [current.user_id]
          });
        }
        return acc;
      }, []);

      const result = selectedValidateurs.map(ts => ({
        missionaire_id: ts.user_id,
        validateurs: ts.validate.map(tr => tr.superior_id)
      }));


      const mergedValidateurs = result.map(item => {
        const foundInFinal = validateurFinal.find(v => v.missionaire_id === item.missionaire_id);
        
        return {
          missionaire_id: item.missionaire_id,
          validateurs: foundInFinal ? foundInFinal.validateurs : item.validateurs
        };
      });

      validateurFinal.forEach(vfItem => {
        if (!mergedValidateurs.some(m => m.missionaire_id === vfItem.missionaire_id)) {
          mergedValidateurs.push(vfItem);
        }
      });

      const finalValidateurs = mergedValidateurs.map(item => ({
        missionaire_id: item.missionaire_id,
        validateurs: [...new Set(item.validateurs)]
      }));

      TDRService.sendmission(missionId,finalValidateurs).then((result) => {
        if (result) {
            setIsloading(false);
            setMessage({ ...message, open: true, color: 'green', messageInfo: "Succès" });
            setTimesheetDialog(true);
            setOpendialogue(false);
            setLoading(false);
            // navigate('/mission/planning_mission');
        }
        else
        {
           setIsloading(false);
           setMessage({ ...message, open: true, color: 'red', messageInfo: result.message });
        }
      });
      
   };

  return (
    <MainContainer {...headerDataMission}>
     <Message open={open} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} />
         <Grid 
                container 
                spacing={3} 
                style={{ 
                    width: "100%", 
                    height: "100vh", 
                    padding: "24px",
                    boxSizing: "border-box"
                }}
                >
                <Grid 
                    item 
                    xs={12} 
                    style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: "16px 0",
                    marginTop: "auto"
                    }}
                >
                    <div style={{ display: 'flex', gap: '16px' }}>
                    <Button variant="contained" color="secondary" style={{marginBottom:"40px",  padding: "10px 24px",
                        borderRadius: "8px",
                        fontWeight: 600}} onClick={handleClose} autoFocus>
                       Annuler
                    </Button> 
                    <Button 
                        variant="contained" 
                        color="primary"
                        onClick={handleretour}
                        style={{ marginBottom:"40px",
                        padding: "10px 24px",
                        borderRadius: "8px",
                        fontWeight: 600
                        }}
                    >
                        Retour
                    </Button>

                     <Button 
                        variant="contained" 
                        color="primary"
                        onClick={handleValidate}
                        style={{ marginBottom:"40px",
                        padding: "10px 24px",
                        borderRadius: "8px",
                        fontWeight: 600
                        }}
                    >
                         Envoyer pour validation
                    </Button>
                    </div>
                    
                    {filename && (
                          <Typography 
                            variant="caption" 
                            style={{ 
                                color: "#666",
                                fontStyle: 'italic'
                            }}
                            >
                            Dernière mise à jour: {new Date().toLocaleDateString('fr-FR')} à {new Date().toLocaleTimeString('fr-FR', {
                                hour: '2-digit',
                                minute: '2-digit'
                            })}
                         </Typography>
                     )}
                </Grid>
                <Grid item xs={12} style={{ height: "calc(100vh - 120px)" }}>
                    <Paper 
                    elevation={3} 
                    style={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "32px",
                        borderRadius: "12px",
                        backgroundColor: "#fafafa"
                    }}
                    >
                    {loading ? (
                        <div style={{ 
                        display: 'flex', 
                        flexDirection: 'column', 
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '24px'
                        }}>
                        <CircularProgress 
                            size={80} 
                            thickness={4}
                            style={{ color: "#1976d2" }}
                        />
                        <Typography 
                            variant="h6" 
                            style={{ 
                            color: "#555",
                            fontWeight: 500,
                            marginTop: 8
                            }}
                        >
                            Chargement du TDR en cours...
                        </Typography>
                        <Typography 
                            variant="body2" 
                            style={{ 
                            color: "#888",
                            textAlign: 'center',
                            maxWidth: '400px'
                            }}
                        >
                            Veuillez patienter pendant le téléchargement du document.
                        </Typography>
                        </div>
                    ) : error ? (
                        <div style={{ 
                        display: 'flex', 
                        flexDirection: 'column', 
                        alignItems: 'center',
                        gap: '20px',
                        textAlign: 'center'
                        }}>
                        <Typography 
                            variant="h5" 
                            style={{ 
                            color: "#d32f2f",
                            fontWeight: 600
                            }}
                        >
                            Erreur de chargement
                        </Typography>
                        <Typography 
                            variant="body1" 
                            style={{ 
                            color: "#666",
                            maxWidth: '500px'
                            }}
                        >
                            {error}
                        </Typography>
                        <Button 
                            variant="outlined" 
                            color="primary"
                            onClick={() => window.location.reload()}
                            style={{ marginTop: 8 }}
                        >
                            Réessayer
                        </Button>
                        </div>
                    ) : filename ? (
                        <div style={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        borderRadius: "8px",
                        overflow: "hidden",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
                        }}>
                        <div style={{
                            padding: "16px",
                            backgroundColor: "#1976d2",
                            color: "white",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center"
                        }}>
                            <Typography variant="h6">
                              TERMES DE REFERENCES
                            </Typography>
                            <Button
                            variant="contained"
                            style={{
                                backgroundColor: "white",
                                color: "#1976d2",
                                fontWeight: 600
                            }}
                            onClick={() => window.open(filename, '_blank')}
                            >
                            Ouvrir dans un nouvel onglet
                            </Button>
                        </div>
                        <div style={{
                            flex: 1,
                            minHeight: 0,
                            overflow: "auto"
                        }}>
                            <AllPages pdf={filename} />
                        </div>
                        </div>
                    ) : (
                        <div style={{ 
                        display: 'flex', 
                        flexDirection: 'column', 
                        alignItems: 'center',
                        gap: '20px',
                        textAlign: 'center'
                        }}>
                        <Typography 
                            variant="h5" 
                            style={{ 
                            color: "#757575",
                            fontWeight: 500
                            }}
                        >
                            Aucun rapport disponible
                        </Typography>
                        <Typography 
                            variant="body1" 
                            style={{ 
                            color: "#9e9e9e",
                            maxWidth: '400px'
                            }}
                        >
                            Aucun document n'est actuellement disponible pour affichage.
                        </Typography>
                        </div>
                    )}
                    </Paper>
                </Grid>
                </Grid>
                <>
                <Dialog open={opendialogue} onClose={handleCloseDialogue} maxWidth="md" fullWidth>
                    <DialogTitle sx={{ 
                        textAlign: 'center',
                        borderBottom: '1px solid #e0e0e0',
                        pb: 2,
                        mx: 2 
                    }}>
                        Confirmation des validateurs du Termes de Référence (TDR)
                    </DialogTitle>
                    
                    <DialogContent>
                        <TableContainer>
                        <Table>
                            <TableHead>
                            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                                <TableCell><strong>Missionnaires</strong></TableCell>
                                <TableCell><strong>Liste des validateurs</strong></TableCell>
                            </TableRow>
                            </TableHead>
                            <TableBody>
                            {selectedValidateurs.map((missionaire, index) => {
                                const validateursMissionaire = missionaire.validate;
                                
                                return (
                                <TableRow key={index}>
                                    <TableCell>{missionaire.nom}</TableCell>
                                    <TableCell>
                                    {validateursMissionaire.length > 0 ? (
                                        validateursMissionaire.map((ts, idx) => (
                                        <li 
                                            key={`${ts.superior_id}_${idx}`}
                                            style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            padding: '8px 12px',
                                            marginBottom: '8px',
                                            backgroundColor: '#f5f5f5',
                                            borderRadius: '4px',
                                            borderLeft: '3px solid #1976d2'
                                            }}
                                        >
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <span style={{ 
                                                fontWeight: 'bold', 
                                                marginRight: '12px',
                                                color: '#1976d2',
                                                minWidth: '24px'
                                            }}>
                                                {idx + 1}.
                                            </span>
                                            <span>{ts.nom}</span>
                                            </div>
                                        </li>
                                        ))
                                    ) : (
                                        <span>Aucun validateur</span>
                                    )}
                                    </TableCell>
                                </TableRow>
                                );
                            })}
                            </TableBody>
                        </Table>
                        </TableContainer>
                    </DialogContent>
                    
                    <DialogActions>
                        <Button onClick={handleCloseDialogue} color="primary">
                        Fermer
                        </Button>
                        <LoadingButton
                        onClick={handleValidateConfirm}
                          loading={isLoading} 
                        color="primary"
                        variant="contained"
                        >
                        Confirmer
                        </LoadingButton>
                    </DialogActions>
                    </Dialog>

                    <Dialog open={timesheetDialog} onClose={() => setTimesheetDialog(false)} maxWidth="sm" fullWidth>
                        <DialogTitle sx={{ 
                            textAlign: 'center',
                            borderBottom: '1px solid #e0e0e0',
                            pb: 2,
                            mx: 2
                        }}>
                            Elaboration timesheet de mission
                        </DialogTitle>
                        <DialogContent>
                            <Typography variant="body1" sx={{ textAlign: 'center', mb: 2 }}>
                                Voulez-vous élaborer le timesheet de mission maintenant ?
                            </Typography>
                        </DialogContent>
                        <DialogActions sx={{ justifyContent: 'center', mb: 2 }}>
                            <Button onClick={() => navigate('/mission/planning_mission')} color="primary" variant="outlined">
                                Plus tard
                            </Button>
                            <Button onClick={() => {
                                setTimesheetDialog(false);
                                navigate(`/mission/timesheet/add/${missionId}/${firstAgendaId}/0`);
                            }} color="primary" variant="contained">
                                Élaborer maintenant
                            </Button>
                        </DialogActions>
                    </Dialog>
                </>
    </MainContainer>
  );
}
